import { formatInTimeZone } from "date-fns-tz";

/**
 * Formats a proposal ISO timestamp as dd/MM/yyyy in UTC. Shared by the
 * backoffice management screens (list/detail) and the legacy client viewer,
 * so it lives outside both to keep them from depending on each other.
 */
export const formatProposalDate = (iso: string | undefined | null): string => {
  if (!iso) {
    return "—";
  }

  const timestamp = Date.parse(iso);
  if (Number.isNaN(timestamp)) {
    return "—";
  }

  return formatInTimeZone(iso, "UTC", "dd/MM/yyyy");
};
